import makeStyles from '@material-ui/core/styles/makeStyles'

export const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 12
  },
  flexDisplay: {
    display: 'flex',
    height: 'fit-content',
    minHeight: 'calc(100vh - 390px)',
    backgroundColor: theme.palette.background.default,
    borderRadius: 12
    // paddingBottom: 20
  },
  titleAndList: {
    width: '20%'
    // height: 'calc(100vh - 390px)'
  },
  pageContainer: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center'
  }
}))
